// extracted by mini-css-extract-plugin
module.exports = {"historyCollectCard":"HistoryCollectCard_historyCollectCard__23IAx","requestBorder":"HistoryCollectCard_requestBorder__zobGg"};